<script setup lang="ts">
import type { PropertyOnPage } from '#shared/property/api-types';
import type { DialogMediaType } from '#shared/property/media';

defineProps<{
  property: PropertyOnPage
  title: string
}>();

const emit = defineEmits<{
  share: []
  contact: []
}>();

const open = defineModel<boolean>({ default: false });

const selectedMediaType = ref<DialogMediaType>('photo');
</script>

<template>
  <IadDialog
    v-model="open"
    modal-name="property_media"
    variant="fullscreen"
  >
    <template #top-actions>
      <div class="flex justify-between pb-s">
        <div class="flex gap-xs">
          <IadBtn
            icon
            variant="outlined"
            @click="emit('share')"
          >
            <Icon name="iad-icon:share" />
          </IadBtn>
        </div>
      </div>
    </template>

    <template #top-content>
      <PropertyFilterInputMedia
        v-model="selectedMediaType"
        :property
      />
    </template>

    <div class="flex max-w-[51rem] lg:px-m pb-m lg:h-[calc(100vh-20rem)] mx-auto">
      <PropertyDialogMediaPhotos
        v-if="selectedMediaType === 'photo'"
        :property
        :title
      />
      <PropertyDialogMediaVideo
        v-else-if="selectedMediaType === 'virtual-tour'"
        :property
        :title
        variant="virtual-tour"
      />
      <PropertyDialogMediaVideo
        v-else-if="selectedMediaType === 'video'"
        :property
        :title
        variant="video"
      />
    </div>
    <template #actions>
      <PropertyDialogAgentFooterActions
        v-if="property.agent"
        :agent="property.agent"
        @contact="emit('contact')"
      />
    </template>
  </IadDialog>
</template>
